import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, FileText, Tags, BookUser, Home, Inbox, ScrollText, Users, LogOut, ExternalLink, ClipboardCheck, MessageCircle } from "lucide-react";
import { useAuth } from "./AuthContext";
import { LogoSymbol } from "@/components/brand/Logo";

const LINKS = [
  { to: "/admin", label: "Overview", Icon: LayoutDashboard, end: true },
  { to: "/admin/articles", label: "Articles", Icon: FileText },
  { to: "/admin/categories", label: "Categories", Icon: Tags },
  { to: "/admin/directory", label: "Directory", Icon: BookUser },
  { to: "/admin/homepage", label: "Homepage", Icon: Home },
  { to: "/admin/reviews", label: "Content reviews", Icon: ClipboardCheck },
  { to: "/admin/enquiries", label: "Enquiries", Icon: Inbox, admin: true },
  { to: "/admin/feedback", label: "Feedback", Icon: MessageCircle, admin: true },
  { to: "/admin/audit", label: "Audit log", Icon: ScrollText, admin: true },
  { to: "/admin/users", label: "Team", Icon: Users, admin: true },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const links = LINKS.filter((l) => !l.admin || user.role === "admin");
  return (
    <div className="min-h-screen bg-cream lg:grid lg:grid-cols-[250px_1fr]" data-testid="admin-layout">
      <aside className="bg-[#1E2326] text-cream lg:min-h-screen p-4 lg:p-6 flex lg:flex-col gap-4 overflow-x-auto">
        <Link to="/admin" className="flex items-center gap-2 shrink-0"><LogoSymbol size={32} /><span className="font-serif text-lg hidden lg:inline">Admin</span></Link>
        <nav aria-label="Admin" className="flex lg:flex-col gap-1 lg:mt-6">
          {links.map(({ to, label, Icon, end }) => (
            <NavLink key={to} to={to} end={end} className={({ isActive }) => `flex items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm font-medium whitespace-nowrap ${isActive ? "bg-cream text-ink" : "text-cream/80 hover:bg-white/10"}`} data-testid={`admin-nav-${label.toLowerCase().replace(/\s/g, "-")}`}>
              <Icon className="h-4 w-4" aria-hidden="true" />{label}
            </NavLink>
          ))}
        </nav>
        <div className="lg:mt-auto flex lg:flex-col gap-2 text-sm shrink-0">
          <p className="hidden lg:block text-cream/70 break-all" data-testid="admin-current-user">{user.email}<br /><span className="uppercase text-xs tracking-wider">{user.role}</span></p>
          <a href="/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-cream/80 hover:text-white px-3 py-2"><ExternalLink className="h-4 w-4" aria-hidden="true" />View site</a>
          <button onClick={logout} className="flex items-center gap-2 text-cream/80 hover:text-white px-3 py-2" data-testid="admin-logout-button"><LogOut className="h-4 w-4" aria-hidden="true" />Sign out</button>
        </div>
      </aside>
      <main className="p-5 sm:p-8 lg:p-10 min-w-0"><Outlet /></main>
    </div>
  );
}
